import type { ReactNode } from 'react';

/**
 * The shared geometry of one Timeline row — the 4-column grid (icon · checkpoint
 * · status · details) plus the bottom connector line. Used by the loading
 * skeleton and the empty-state placeholder so their row layout stays in lockstep
 * (a single place to change column widths / connector offsets), each supplying
 * its own cell contents as children.
 */
export function TimelineRowFrame({ children }: { children: ReactNode }) {
  return (
    <div className='after:bg-border relative grid grid-cols-[88px_minmax(0,2fr)_minmax(0,1fr)_minmax(0,3fr)] items-center gap-4 px-6 py-6 after:absolute after:right-6 after:bottom-0 after:left-32 after:h-px after:content-[""] last:after:hidden'>
      {children}
    </div>
  );
}
